var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5698 5.59813V31.037C31.5677 32.109 31.1865 33.1366 30.5094 33.8954C29.8323 34.6542 28.9143 35.0827 27.9557 35.0873H5.59064C4.6334 35.0827 3.71653 34.6554 3.03965 33.8985C2.36277 33.1415 1.98068 32.1162 1.97656 31.0458V5.59813C1.97862 4.52615 2.3598 3.49861 3.0369 2.73978C3.71401 1.98095 4.63205 1.55247 5.59064 1.54785H27.9557",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6089 3.55964C32.041 3.55964 32.3912 3.16798 32.3912 2.68485C32.3912 2.20172 32.041 1.81006 31.6089 1.81006C31.1769 1.81006 30.8267 2.20172 30.8267 2.68485C30.8267 3.16798 31.1769 3.55964 31.6089 3.55964Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6831 13.0689C23.1152 13.0689 23.4654 12.6773 23.4654 12.1941C23.4654 11.711 23.1152 11.3193 22.6831 11.3193C22.2511 11.3193 21.9009 11.711 21.9009 12.1941C21.9009 12.6773 22.2511 13.0689 22.6831 13.0689Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7457 8.10059C10.0076 8.16239 9.3177 8.53392 8.81428 9.14068C8.31086 9.74745 8.03116 10.5446 8.03125 11.3723V25.264C8.03331 26.1356 8.34387 26.9709 8.89503 27.5872C9.44619 28.2036 10.1931 28.5509 10.9726 28.5532H17.6923",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6922 28.5525H23.3949C24.1743 28.5502 24.9213 28.2029 25.4724 27.5866C26.0236 26.9702 26.3342 26.1349 26.3362 25.2633V11.3716C26.3342 10.5 26.0236 9.6647 25.4724 9.04835C24.9213 8.43201 24.1743 8.08472 23.3949 8.08242H10.9725C10.8971 8.07344 10.821 8.07344 10.7456 8.08242",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7485 13.7166C17.8684 13.3434 16.9046 13.2946 15.9979 13.5776C15.0913 13.8606 14.2894 14.4604 13.7093 15.2894C13.1292 16.1183 12.8015 17.1331 12.7739 18.1852C12.7463 19.2374 13.0203 20.2718 13.556 21.1374C14.0916 22.003 14.8607 22.6543 15.751 22.9962C16.6412 23.338 17.6059 23.3525 18.5041 23.0376C19.4023 22.7226 20.1868 22.0947 20.7431 21.2456C21.2994 20.3965 21.5982 19.3706 21.596 18.318",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5c988cb240df6eca70b6227f3507ad77.svg";
export { ForwardRef as ReactComponent };